import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { useNotification } from "~hooks/useNotification.ts";
import type { LeaderCriteriaRuleResponse } from "~pages/LeaderCriteria/types/leaderCriteriaRule.ts";
import type { CreateLeaderCriteriaRuleModel } from "~pages/LeaderCriteria/types/leaderCriteriaRuleModel.ts";

export const useCreateLeaderCriteriaRule = () => {
  const { sport, organizationId, leaderCriteriaId } = useParams();
  const request = useApi();
  const queryClient = useQueryClient();
  const { formatMessage } = useIntl();
  const notification = useNotification();

  return useMutation<LeaderCriteriaRuleResponse, Error, CreateLeaderCriteriaRuleModel>({
    mutationFn: async (body) =>
      await request<LeaderCriteriaRuleResponse>(`${sport}/o/${organizationId}/statistics/leaders/criteria/${leaderCriteriaId}/qualifiers`, {
        method: "POST",
        body,
      }),
    onSuccess: async () => {
      notification.success({
        message: formatMessage({ id: "leaders.rule.create.success" }),
        placement: "bottomRight",
      });

      await queryClient.invalidateQueries({ queryKey: ["leaderCriteriaRules", sport, organizationId, leaderCriteriaId] });
    },
  });
};
